module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av12-81676aba9af3d6116515c65a7dfcf2cd.jpg";